import { render, staticRenderFns } from "./home-cooperation.vue?vue&type=template&id=cded47d8&scoped=true&"
import script from "./home-cooperation.vue?vue&type=script&lang=js&"
export * from "./home-cooperation.vue?vue&type=script&lang=js&"
import style0 from "./home-cooperation.vue?vue&type=style&index=0&id=cded47d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cded47d8",
  null
  
)

export default component.exports